export default "__VITE_ASSET__Dxx3gY$p__"